import { api } from '~/services/api'

/**
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
export const apiGetListBusNotCheckIn = (params) => {
  const uri = `/human-resource/attendance-not-checkin`
  return api.get(uri, params)
}

